


































































































































































































































































import { Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { mixins } from 'vue-class-component'
import UserModel from '@/_models/UserModel'

// Common
import NotFound from '@/components/common/NotFound.vue'

// Component
import UserUpsertForm from '@/components/user/forms/UserUpsertForm.vue'

// Shared
import FilterDropdown from '@/components/shared/FilterDropdown.vue'
import TablePagination from '@/components/shared/TablePagination.vue'

// Mixins
import TableSortMixin from '@/components/mixins/TableSortMixin.vue'
import * as DownloadCsv from 'vue-json-csv'
import { Filter } from '@/_utils/filter'

@Component({
  components: {
    DownloadCsv,
    FilterDropdown,
    NotFound,
    TablePagination,
    UserUpsertForm,
  },
  computed: {
    ...mapGetters('users', {
      canEdit: 'canEdit',
    }),
    ...mapGetters('users', {
      canDelete: 'canDelete',
    }),
  },
})
export default class UserList extends mixins(TableSortMixin) {
  // data
  filterUtilTableSort: any = new Filter('filter_userlist_table_sort')
  filterUtilPage: any = new Filter('filter_userlist_page')
  pageFilters: any = {
    currentPage: 1,
    perPage: 10,
    selectedFilter: 'name',
    searchQuery: '',
    activeTab: 0, // 0: people, 1: things
  }

  numofPage: number = 1
  selected: any = {}
  isFormModalActive: boolean = false
  isImportCsvModalActive: boolean = false

  isNew: boolean = false
  canEdit!: boolean
  canDelete!: boolean
  filedNameLUT: any = {
    _id: 'UUID',
    user_id: 'label.user_id',
    name: 'label.username',
    category_name: 'label.category',
    category_id: 'label.category_id',
    san_id: 'label.card_number',
    major: 'label.major',
    minor: 'label.minor',
  }

  // Import/Export csv setting
  csvFile: any = null
  csvFields: any = [
    '_id',
    'user_id',
    'name',
    'category_id',
    'category_name',
    'san_id',
  ]

  // computed
  get users(): UserModel[] {
    const users = this.$store.state.users.all.items_raw
    this.numofPage = Math.ceil(users.length / this.pageFilters.perPage)

    return users
  }

  get isLoading(): boolean {
    return this.$store.state.users.loading
  }

  get filteredData(): UserModel[] {
    const targetField: string = this.pageFilters.selectedFilter
    if (!this.users) {
      return []
    }

    return this.users.filter((item: UserModel): boolean => {
      const searchKey =
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.pageFilters.searchQuery.toString().toLowerCase()) !==
          -1 || item._id === this.pageFilters.searchQuery // Can search by uuid

      const validPeople =
        item.user_type === 'people' && this.pageFilters.activeTab === 0
      const validThing =
        item.user_type === 'things' && this.pageFilters.activeTab === 1

      return searchKey && (validPeople || validThing)
    })
  }

  handleOpenModalEdit(data): void {
    this.isFormModalActive = true
    this.selected = Object.assign({}, data)
    this.isNew = false
  }

  handleOpenModalAdd(): void {
    this.isFormModalActive = true
    this.selected = new UserModel()
    this.isNew = true
  }

  handleOpenModalImportCSV(): void {
    this.isImportCsvModalActive = true
  }

  handleCancelImportModal(): void {
    this.isImportCsvModalActive = false
    this.csvFile = null
  }

  async handleImportCSV(): Promise<void> {
    this.$store.dispatch('users/importCSV', this.csvFile).then((resp) => {
      this.handleCancelImportModal()
      this.$buefy.toast.open(this.$t('messages.save_success') as string)
    })
  }

  // methods
  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  confirmCustomDelete(data): void {
    this.selected = data
    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t('messages.are_you_sure_want_to_delete') as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        this.$store.dispatch('users/hasRefs', this.selected).then((result) => {
          if (result.has_reference) {
            this.confirmForceDelete(data)
          } else {
            this.processDelete(data)
          }
        })
      },
    })
  }

  confirmForceDelete(data): void {
    this.selected = data
    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t(
        'messages.has_refs_data_are_you_sure_want_to_delete'
      ) as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        this.processDelete(data)
      },
    })
  }

  processDelete(data): void {
    this.selected = data
    this.$store.dispatch('users/deleteOne', this.selected).then(() => {
      this.selected = {}
      this.$buefy.toast.open(this.$t('messages.delete_success') as string)
    })
  }

  beforeDestroy() {
    this.filterUtilPage.save(this.pageFilters)
    this.$store.dispatch('resetAllModulesState', ['users'])
  }

  // After page created
  created() {
    this.pageFilters = this.filterUtilPage.get(this.pageFilters)

    this.$store.dispatch('users/getUsersRaw')
  }
}
